/** @jsxImportSource @emotion/react */
import { Stack, useTheme } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";

interface Props {
  isLocked: boolean;
  imageFilename: string;
  cardName: string;
}

export const LockUnlockCardImage = ({
  isLocked,
  imageFilename,
  cardName,
}: Props) => {
  const theme = useTheme();
  return (
    <Stack gap={8}>
      <div css={{ position: "relative" }}>
        <img
          src={require(`../../images/cards-blank/${imageFilename}`).default}
          alt={`${cardName} Card`}
          css={{ maxWidth: "100%", width: "350px", height: "auto" }}
        />
        {isLocked && (
          <>
            <div
              css={{
                backgroundColor: theme.colors.white,
                opacity: 0.65,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: "0",
              }}
            />
            <div
              css={{
                alignItems: "center",
                backgroundColor: "rgba(0,0,0,0.45)",
                display: "flex",
                justifyContent: "center",
                borderRadius: "400px",
                height: "128px",
                width: "128px",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                margin: "auto",
                "& svg > path": {
                  stroke: theme.colors.white,
                  strokeWidth: "5px",
                },
              }}
            >
              <SvgInline name="third-party-authority" width="64" strokeWhite />
            </div>
          </>
        )}
      </div>
    </Stack>
  );
};
